import { useState } from 'react';

import PropTypes from 'prop-types';

import Button from '#globalComponents/Button/Button';
import FormField from '#globalComponents/Forms/FormField';
import TextInput from '#globalComponents/Forms/TextInput';
import Panel from '#globalComponents/Overlay/Panel';
import Popover from '#globalComponents/Overlay/Popover';

import { RADIUS_KM } from '../../constants/conversation';

const isValidRadius = (value) => Number.isInteger(value) && value >= RADIUS_KM.min && value <= RADIUS_KM.max;

/**
 * The radius of a city profile as an inline editor. Saving hands the new radius up and closes;
 * the server answers with a new assistant turn, errors arrive as the global toast.
 */
const RadiusPopover = ({ city, radius, disabled = false, onSave }) => {
	const [open, setOpen] = useState(false);
	const [value, setValue] = useState(radius);
	const valid = isValidRadius(value);

	const openEditor = () => {
		setValue(radius);
		setOpen(true);
	};
	const save = (event) => {
		event.preventDefault();
		if (!valid) return;
		setOpen(false);
		if (value !== radius) onSave(value);
	};

	return (
		<Popover
			open={open}
			onClose={() => setOpen(false)}
			size="s"
			trigger={
				<button
					type="button"
					onClick={openEditor}
					disabled={disabled}
					title={disabled ? 'Umkreis ist änderbar, sobald der Assistent fertig ist' : 'Umkreis ändern'}
					className="text-left underline decoration-dotted underline-offset-2 hover:text-primary-600 disabled:cursor-default disabled:no-underline disabled:hover:text-text"
				>
					{city} · {radius} km
				</button>
			}
		>
			<form onSubmit={save}>
				<Panel.Body>
					<FormField
						label="Umkreis in km"
						htmlFor="agent-radius"
						hint={`${RADIUS_KM.min} bis ${RADIUS_KM.max} km`}
					>
						<TextInput
							id="agent-radius"
							type="number"
							min={RADIUS_KM.min}
							max={RADIUS_KM.max}
							step={1}
							value={value}
							onChange={(e) => setValue(e.target.value === '' ? '' : Number(e.target.value))}
							error={!valid}
							className="max-w-[8rem]"
						/>
					</FormField>
				</Panel.Body>
				<Panel.Footer>
					<Button type="submit" size="sm" disabled={!valid} className="ml-auto">
						Speichern
					</Button>
				</Panel.Footer>
			</form>
		</Popover>
	);
};

RadiusPopover.propTypes = {
	city: PropTypes.string.isRequired,
	radius: PropTypes.number.isRequired,
	disabled: PropTypes.bool,
	onSave: PropTypes.func.isRequired,
};

export default RadiusPopover;
